import {
  Badge,
  Button,
  Card,
  Form,
  Icon,
  Input,
  notification,
  Switch,
  Table,
  Tooltip
} from 'antd'
import React, { Component } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { SendTemplateEmail } from '../../../email/actions'
import { getAllAbstracts,AcceptanceAbstract } from '../actions'
import AbstractActivityList from '../AbstractActivityList'
import AbstractFilters from './AbstractFilters'
import { getPushPathWrapper } from '../../../../routes'
// import ComposingAbstractDrawer from './ComposingAbstractDrawer'

@Form.create()
class AcceptedAbstract extends Component {
  state = {
    filters: {},
    visibleDrawer: false,
    abstract: {},
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Accepted Abstract'
      }
      let data = await dispatch(getAllAbstracts({ ...obj }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => { this.table.current.reload() }

  reloadTable = data => {
    if (data.fromDate && data.toDate) {
      data['createdAt'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  // handleResendAcceptance = record => {
  //   let { dispatch } = this.props
  //   chooseEmailModalFxn({
  //     callback: async email => {
  //       let obj = {
  //         abstractId: record._id,
  //         fromEmail: email,
  //         template: 'acceptanceAbstract',
  //         type: 'abstract'
  //       }
  //       let resp = await dispatch(
  //         SendTemplateEmail({
  //           email,
  //           id: record._id,
  //           obj,
  //           template: obj.template
  //         })
  //       )
  //       if (resp && resp.success) {
  //         notification.success({ message: resp.message })
  //         this.reload()
  //       }
  //     }
  //   })
  // }

  handleResendAcceptance = record => {
    let { dispatch } = this.props;

    chooseEmailModalFxn({
      callback: async email => {
        // 1. Prepare payload exactly like your handleSubmit
        const valData = {
          abstractId: record._id, // Use record instead of abstract
          fromEmail: email,
          approvedAbstractPayment: record.approvedAbstractPayment || record.publicationCharges || 0,
          status: 'Accepted Abstract',
          isUpdate: true,
          sendEmail: true
        };

        // 2. Logic for template
        valData.template = valData.approvedAbstractPayment > 0
          ? 'acceptanceAbstract'
          : 'acceptanceAbstractWithoutCharges';

        // 3. Dispatch the SAME action
        let { success } = await dispatch(AcceptanceAbstract(valData));

        if (success) {
          notification.success({
            message: 'Success',
            description: 'Acceptance email resent successfully.'
          });

          // Refresh the list to reflect any potential updates
          dispatch({ type: 'START_LOAD_ABSTRACT' });
          this.reload();
        }
      }
    });
  }
  render() {
    const { dispatch } = this.props;
    const columns = [
      {
        key: 'actions',
        title: 'Abstract No',
        width: '85px',
        render: (val, record) => (
          <Tooltip title="View Details">
            <a href={`/abstract/view/${record._id}`}>{record.abstractNo || record.onlineAbstractId}</a>
          </Tooltip>
        )
      },
      {
        title: 'Submitted Date',
        key: 'createdAt',
        dataIndex: 'createdAt',
        width: '100px',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Abstract Title',
        key: 'titleOfAbstract',
        width: '200px',
        dataIndex: 'titleOfAbstract',
        render: item => item ? ReactHtmlParser(item) : null
      },
      {
        title: 'Country',
        key: 'country',
        dataIndex: 'country'
      },
      {
        title: 'Author',
        key: 'authorName',
        dataIndex: 'authorName'
      },
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email'
      },
      {
        title: 'Approval Date',
        key: 'approvedAbstractDate',
        width: 100,
        dataIndex: 'approvedAbstractDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Acceptance Date',
        key: 'approvedAbstractPaymentDate',
        width: 100,
        dataIndex: 'approvedAbstractPaymentDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Approval Amount',
        key: 'publicationCharges',
        dataIndex: 'publicationCharges'
      },
      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => (
          <>
            <Button onClick={() => this.handleResendAcceptance(record)} className={'roundSmallBtn'}>
              Resend Acceptance
            </Button>
            <Button
              className={'roundSmallBtn'}
              onClick={() => {
                dispatch(
                  getPushPathWrapper('onlineAbstractsGroup.addDoiAbstract', { id: record._id })
                )
              }}>
              For DOI
            </Button>
            <Button
              className={'roundSmallBtn'}
              onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
              Abstract Activities
            </Button>
          </>
        )
      }
    ]

    return (
      <PageHeaderWrapper title={`Accepted Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters callback={data => this.reloadTable(data)} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>

        {/*{this.state.visibleDrawer && (*/}
        {/*  <ComposingAbstractDrawer*/}
        {/*    visible={this.state.visibleDrawer}*/}
        {/*    abstract={this.state.abstract}*/}
        {/*    abstractId={this.state.abstract._id}*/}
        {/*    edit={false}*/}
        {/*    onClose={() => this.setState({ visibleDrawer: false })}*/}
        {/*    callback={this.reload}*/}
        {/*  />*/}
        {/*)}*/}

        {this.state.visibleActivityList && (
          <AbstractActivityList
            abstractId={this.state.abstract._id}
            abstractNo={this.state.abstract.abstractNo || this.state.abstract.onlineAbstractId}
            visible={this.state.visibleActivityList}
            onClose={() => this.setState({ visibleActivityList: false })}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

export default connect(null)(AcceptedAbstract)
